/** Building-wise table helpers for EB bill views (manual list, preview modal). */

export const withRoomGroupKey = (rows = []) => (
  rows.map(row => ({
    ...row,
    room_group_key: row.room_id != null
      ? `${row.building_id}-${row.room_id}`
      : `invoice-${row.invoice_id}`,
  }))
);

export const EB_BILL_ROW_GROUP_CONFIG = {
  groups: [
    { key: 'room_group_key', columns: ['room_name'] },
  ],
};
